import { createOrgRoute, postAListingRoute } from '#/routing/routes';

import type { PostOnIdealistDropdownData } from './types/PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataEs: PostOnIdealistDropdownData = {
  search: {
    title: 'Publica',
    items: [
      {
        type: 'post-a-listing',
        title: 'Publica una Oportunidad',
        href: postAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Suma tu Organización',
        href: createOrgRoute.with({}),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'funding',
        title: 'Recursos para Recaudar Fondos',
        description:
          'Vías de financiación para construir en el impacto que buscas.',
        href: '/es/recursos-recaudacion-fondos',
      },
      {
        type: 'employer-resources',
        title: 'Herramientas para Reclutadores',
        description:
          'Herramientas y recursos para contratar y retener el mejor talento para tu causa.',
        href: '/es/orgs/encuentra-talento',
      },
    ],
  },
};
